import React from 'react';

const Error = () => {
    return (
        <div>
            <p>Erro 404</p>
        </div>

    );
}

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error.js